import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Icon } from '@iconify/react';
import $ from 'jquery';
import 'magnific-popup';

function Dashboard() {
  const popupRef = useRef();
  useEffect(() => {
    // Initialize Magnific Popup
    $(popupRef.current).magnificPopup({
      type: 'image',
      closeOnContentClick: true,
      image: {
        verticalFit: true,
      },
    });
  }, []);
  const handleOpenPopup = () => {
    $(popupRef.current).click(); // Simulate click
  };

  const [student, setStudent] = useState(null);
  useEffect(() => {
    axios.get('/api/student/student-info', {
      withCredentials: true
    })
    .then((response) => setStudent(response.data))
    .catch((error) => console.error('Error fetching student data:', error));
  }, []);
  
  const [dashboardCounts, setDashboardCounts] = useState({
    notification_total: 0,
    diary_total: 0,
    timetable_total: 0,
    assignment_total: 0,
    notes_total: 0
  });
  const fetchDashboardDetails = async () => {
    try {
      const res = await axios.get('/api/student/get-student-dashboard-details');
      setDashboardCounts(res.data);
    } catch (error) {
      console.error('Failed to fetch dashboard data:', error);
    }
  };

  useEffect(() => {
    fetchDashboardDetails();
  }, []);

  return (
    <div className="row gy-44">
      {/* ======================= First Row Cards Start =================== */}
      <div className="col-xxl-8 mb-20">
        <div className="row gy-3">
          <div className="col-xxl-3 col-sm-6">
            <div className="card h-100 p-0 shadow-sm">
              <div className="card-body p-3">
                <div className="fw-bold text-uppercase card-title mb-1">{student?.student_first_name} {student?.student_father_name} {student?.student_last_name}</div>
                <div className="mb-0 card-title">Register ID: <strong>{student?.regi_id}</strong></div>
                <div className="mb-0 card-title">Class: <strong>{student?.class_name}</strong></div>
                <div className="mb-0 card-title">Division: <strong>{student?.division_name}</strong></div>
                <div className="mb-0 card-title">Roll No: <strong>{student?.roll_no}</strong></div>
                <div className="mb-0 card-title">Academic Year: <strong>{student?.academic_year}</strong></div>

                <button onClick={handleOpenPopup} className="btn btn-primary" style={{ backgroundColor: '#800080', borderColor: '#800080' }}>
                  <span className="h3 mt-0 mb-0"><Icon icon="iconoir:eye" />&nbsp;</span>
                   View Photo
                </button>
                <a ref={popupRef} href={`../${student?.photo}`} className="magnific-image" style={{ display: 'none' }} > Open Image </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-xxl-8">
        <div className="row gy-3">
          <div className="col-xxl-4">
            {/* Total Students */}
            <Link 
              to="/student/attendance"
              className="card p-3 shadow-2 radius-8 border input-form-light h-100 
                        bg-gradient-end-1 bg-red"
              style={{ textDecoration: 'none', cursor: 'pointer' }}
            >
                <div className="card-body p-0">
                  <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-0">
                    <div className="d-flex align-items-center gap-2 mb-12">
                      <span className="mb-0 w-32-px h-48-px text-white text-2xl flex-shrink-0 d-flex justify-content-center align-items-center rounded-circle h6">
                        <Icon icon="ri-group-fill" />
                      </span>
                      <div>
                        <h5 className="mb-0 fw-medium text-secondary-light text-white text-center">
                          { 'Attendance' }
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              
            </Link>
          </div>
          <div className="col-xxl-4 w-50" >
            <Link 
              to="/student/fees"
              className="card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-2 bg-warning"
              style={{ textDecoration: 'none', cursor: 'pointer' }}
            >
              <div className="card-body p-0">
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-0">
                  <div className="d-flex align-items-center gap-2 mb-12">
                    <span className="mb-0 w-32-px h-48-px text-white text-2xl flex-shrink-0 d-flex justify-content-center align-items-center rounded-circle h6">
                      <Icon icon="streamline:bag-dollar-solid" />
                    </span>
                    <div>
                      <span className="mb-0 fw-medium text-secondary-light text-lg text-white">
                        Fees
                      </span>
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-8">
                  <span className="fw-semibold mb-0"></span>
                  <span className="text-sm mb-0 d-flex align-items-center gap-8">
                    <h5 className="fw-semibold mb-0 text-white">{'0'}</h5>
                  </span>
                  </div>
              </div>
            </Link>

          </div>
          <div className="col-xxl-4 w-50" >
            <Link 
              to="/student/notification"
              className="card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-2 bg-blue"
              style={{ textDecoration: 'none', cursor: 'pointer' }}
            >
              <div className="card-body p-0">
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-0">
                  <div className="d-flex align-items-center gap-2 mb-12">
                    <span className="mb-0 w-32-px h-48-px text-white text-2xl flex-shrink-0 d-flex justify-content-center align-items-center rounded-circle h6">
                      <Icon icon="iconoir:bell" />
                    </span>
                    <div>
                      <span className="mb-0 fw-medium text-secondary-light text-lg text-white">
                        Notification
                      </span>
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-8">
                  <p className="fw-semibold mb-0 text-white">New Messages</p>
                  <span className="text-sm mb-0 d-flex align-items-center gap-8">
                    <h5 className="fw-semibold mb-0 text-white">{dashboardCounts.notification_total}</h5>
                  </span>
                  </div>
              </div>
            </Link>
          </div>
          <div className="col-xxl-4 w-50" >
            
            <Link 
              to="/student/diary"
              className="card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-2 bg-cerise"
              style={{ textDecoration: 'none', cursor: 'pointer' }}
            >
              <div className="card-body p-0">
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-0">
                  <div className="d-flex align-items-center gap-2 mb-12">
                    <span className="mb-0 w-32-px h-48-px text-white text-2xl flex-shrink-0 d-flex justify-content-center align-items-center rounded-circle h6">
                      <Icon icon="ri-news-line" />
                    </span>
                    <div>
                      <span className="mb-0 fw-medium text-secondary-light text-lg text-white">
                        Diary
                      </span>
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-8">
                  <p className="fw-semibold mb-0 text-white">To Do Today</p>
                  <span className="text-sm mb-0 d-flex align-items-center gap-8">
                    <h5 className="fw-semibold mb-0 text-white">{dashboardCounts.diary_total}</h5>
                  </span>
                  </div>
              </div>
            </Link>
          </div>

          <div className="col-xxl-4 w-50" >
            <Link 
              to="/student/timetable"
              className="card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-2 bg-cyan"
              style={{ textDecoration: 'none', cursor: 'pointer' }}
            >
              <div className="card-body p-0">
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-0">
                  <div className="d-flex align-items-center gap-2 mb-12">
                    <span className="mb-0 w-32-px h-48-px text-white text-2xl flex-shrink-0 d-flex justify-content-center align-items-center rounded-circle h6">
                      <Icon icon="solar:calendar-outline" />
                    </span>
                    <div>
                      <span className="mb-0 fw-medium text-secondary-light text-lg text-white">
                        Time Table
                      </span>
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-8">
                  <p className="fw-semibold mb-0 text-white"></p>
                  <span className="text-sm mb-0 d-flex align-items-center gap-8">
                    <h5 className="fw-semibold mb-0 text-white">{dashboardCounts.timetable_total}</h5>
                  </span>
                  </div>
              </div>
            </Link>

          </div>

          <div className="col-xxl-4 w-50" >
            <Link 
              to="/student/assignment"
              className="card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-2 bg-strong-yellow"
              style={{ textDecoration: 'none', cursor: 'pointer' }}
            >
              <div className="card-body p-0">
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-0">
                  <div className="d-flex align-items-center gap-2 mb-12">
                    <span className="mb-0 w-32-px h-48-px text-white text-2xl flex-shrink-0 d-flex justify-content-center align-items-center rounded-circle h6">
                      <Icon icon="solar:document-text-outline" />
                    </span>
                    <div>
                      <span className="mb-0 fw-medium text-secondary-light text-lg text-white">
                        Assignment
                      </span>
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-8">
                  <p className="fw-semibold mb-0 text-white"></p>
                  <span className="text-sm mb-0 d-flex align-items-center gap-8">
                    <h5 className="fw-semibold mb-0 text-white">{dashboardCounts.assignment_total}</h5>
                  </span>
                  </div>
              </div>
            </Link>
          </div>

          <div className="col-xxl-4 w-50" >
            <Link 
              to="/student/notes"
              className="card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-2 bg-deep-chestnut"
              style={{ textDecoration: 'none', cursor: 'pointer' }}
            >
              <div className="card-body p-0">
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-0">
                  <div className="d-flex align-items-center gap-2 mb-12">
                    <span className="mb-0 w-32-px h-48-px text-white text-2xl flex-shrink-0 d-flex justify-content-center align-items-center rounded-circle h6">
                      <Icon icon="iconoir:book" />
                    </span>
                    <div>
                      <span className="mb-0 fw-medium text-secondary-light text-lg text-white">
                        Notes
                      </span>
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-8">
                  <p className="fw-semibold mb-0 text-white"></p>
                  <span className="text-sm mb-0 d-flex align-items-center gap-8">
                    <h5 className="fw-semibold mb-0 text-white">{dashboardCounts.notes_total}</h5>
                  </span>
                  </div>
              </div>
            </Link>
          </div>

          <div className="col-xxl-4 w-50" >
            <Link 
              to="/student/events"
              className="card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-2 bg-purple"
              style={{ textDecoration: 'none', cursor: 'pointer' }}
            >
              <div className="card-body p-0">
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-0">
                  <div className="d-flex align-items-center gap-2 mb-12">
                    <span className="mb-0 w-32-px h-48-px text-white text-2xl flex-shrink-0 d-flex justify-content-center align-items-center rounded-circle h6">
                      <Icon icon="solar:calendar-outline" />
                    </span>
                    <div>
                      <span className="mb-0 fw-medium text-secondary-light text-lg text-white">
                        Event
                      </span>
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-8">
                  <p className="fw-semibold mb-0 text-white"></p>
                  <span className="text-sm mb-0 d-flex align-items-center gap-8">
                    <h5 className="fw-semibold mb-0 text-white">{''}</h5>
                  </span>
                  </div>
              </div>
            </Link>
          </div>
          <div className="col-xxl-4 w-50" >
            <Link 
              to="/student/holidays"
              className="card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-2 bg-cheese-orange"
              style={{ textDecoration: 'none', cursor: 'pointer' }}
            >
              <div className="card-body p-0">
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-0">
                  <div className="d-flex align-items-center gap-2 mb-12">
                    <span className="mb-0 w-32-px h-48-px text-white text-2xl flex-shrink-0 d-flex justify-content-center align-items-center rounded-circle h6">
                      <Icon icon="solar:calendar-outline" />
                    </span>
                    <div>
                      <span className="mb-0 fw-medium text-secondary-light text-lg text-white">
                        Holiday
                      </span>
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-8">
                  <p className="fw-semibold mb-0 text-white"></p>
                  <span className="text-sm mb-0 d-flex align-items-center gap-8">
                    <h5 className="fw-semibold mb-0 text-white">{''}</h5>
                  </span>
                  </div>
              </div>
            </Link>

          </div>
          <div className="col-xxl-4 w-50" >
            <Link to="/student/about-institute" className="card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-2 bg-vivid-red">
              <div className="card-body p-0">
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-0">
                  <div className="d-flex align-items-center gap-2 mb-12">
                    <span className="mb-0 w-32-px h-48-px text-white text-2xl flex-shrink-0 d-flex justify-content-center align-items-center rounded-circle h6">
                      <Icon icon="iconoir:bank" />
                    </span>
                    <div>
                      <span className="mb-0 fw-medium text-secondary-light text-lg text-white">
                        About Institute
                      </span>
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-8">
                  <p className="fw-semibold mb-0 text-white"></p>
                  <span className="text-sm mb-0 d-flex align-items-center gap-8">
                    <h5 className="fw-semibold mb-0 text-white">{''}</h5>
                  </span>
                  </div>
              </div>
            </Link>
          </div>
          <div className="col-xxl-4 w-50" >
            <Link to="/student/profile" className="card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-2 bg-dark-gray">
              <div className="card-body p-0">
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-0">
                  <div className="d-flex align-items-center gap-2 mb-12">
                    <span className="mb-0 w-32-px h-48-px text-white text-2xl flex-shrink-0 d-flex justify-content-center align-items-center rounded-circle h6">
                      <Icon icon="iconoir:user" />
                    </span>
                    <div>
                      <span className="mb-0 fw-medium text-secondary-light text-lg text-white">
                        Profile
                      </span>
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-8">
                  <p className="fw-semibold mb-0 text-white"></p>
                  <span className="text-sm mb-0 d-flex align-items-center gap-8">
                    <h5 className="fw-semibold mb-0 text-white">{''}</h5>
                  </span>
                  </div>
              </div>
            </Link>
          </div>
          <div className="col-xxl-4 w-50" >
            <Link to="/student/emergency-contact" className="card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-2 bg-reddish-brown">
              <div className="card-body p-0">
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-0">
                  <div className="d-flex align-items-center gap-2 mb-12">
                    <span className="mb-0 w-32-px h-48-px text-white text-2xl flex-shrink-0 d-flex justify-content-center align-items-center rounded-circle h6">
                      <Icon icon="iconoir:phone" />
                    </span>
                    <div>
                      <span className="mb-0 fw-medium text-secondary-light text-lg text-white">
                        Emergency Call To Institute
                      </span>
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-8">
                  <p className="fw-semibold mb-0 text-white"></p>
                  <span className="text-sm mb-0 d-flex align-items-center gap-8">
                    <h5 className="fw-semibold mb-0 text-white">{''}</h5>
                  </span>
                  </div>
              </div>
            </Link>
          </div>

        </div>
      </div>
    </div>
  );
}

export default Dashboard;
